import CustomEvent from "custom-event";
import { MediaModalItemModel } from "../models/MediaModalModel";
import { PopupModalModel } from "../models/PopupModalModel";
import { MediaType } from "../models/MediaType";

export const ModalAutoActions: Function = () => {
  document.addEventListener("click", (e: any): void => {
    const target: Element = e.target;

    //Info Modals
    const popupModalAction = getSelfOrNearestAncestorByClass(
      target,
      "popupModal__action"
    );
    if (popupModalAction) {
      e.preventDefault();
      const opts = JSON.parse(popupModalAction.getAttribute("data-popupModal"));

      if (!opts) return;
      const el: Element = document.querySelector(opts.text);

      if (el) {
        const content: PopupModalModel = {
          text: el.innerHTML,
          title: opts.title,
        };
        const evt = new CustomEvent("showPopupModal", { detail: { content } });
        window.dispatchEvent(evt);
      }

      return;
    }

    //Image/Video Modals
    const mediaModalAction = getSelfOrNearestAncestorByClass(
      target,
      "mediaModal__action"
    );
    if (mediaModalAction) {
      e.preventDefault();
      const opts = JSON.parse(mediaModalAction.getAttribute("data-mediaModal"));

      if (!opts) return;

      const el: Element = document.querySelector(opts.text);
      if (el) {
        const item: MediaModalItemModel = {
          media: opts.media,
          title: opts.title,
          text: el.innerHTML,
          type: opts.type ? MediaType[opts.type] : MediaType.Image,
        };

        const evt = new CustomEvent("showMediaModal", {
          detail: { content: [item] },
        });
        window.dispatchEvent(evt);
      }

      return;
    }
  });
};

function getSelfOrNearestAncestorByClass(
  el: Element,
  className: string
): Element {
  const maxDepth: number = 5;
  let currentDepth: number = 0;
  let element: any = el;

  do {
    currentDepth++;

    if (element.classList && element.classList.contains(className)) {
      return element;
    }
    element = currentDepth !== maxDepth ? element.parentNode : null;
  } while (element);

  return null;
}
